import * as React from 'react';

export class FilterTrigger extends React.Component<null> {
    toggleFilterMenu(evt: React.MouseEvent<HTMLAnchorElement>) {
        // Toggle Mobile Filter menu
        evt.preventDefault();
        let calContainer = document.querySelector('.cal-container');
        let filterButtonText = document.querySelector('.cal-filters-trigger-text');

        calContainer.classList.toggle('filters-open');

        if (calContainer.classList.contains('filters-open')) {
            filterButtonText.innerHTML = '<span class="visually-hidden">Activate to go</span> Back';
        } else {
            filterButtonText.innerHTML = '<span class="visually-hidden">Activate to display</span> Filters';
        }
    }

    render() {
        return (
            <a className="cal-filters-trigger" href="#filter-nav" onClick={this.toggleFilterMenu}>
                <span className="cal-filters-trigger-text">
                    <span className="visually-hidden">Activate to display</span>
                    Filters
                </span>
            </a>
        );
    }
}

export default FilterTrigger;



// WEBPACK FOOTER //
// ./app/calendar/components/filter-trigger.tsx